import React, { useState } from "react";
import { FormattedHTMLMessage } from "react-intl";

interface EmailMessageComponentProps {
  title?: string | React.ReactNode;
  message?: string | React.ReactNode;
  closing?: string | React.ReactNode;
  helpRequestResponse?: "green" | "blue";
  onResendClick?: () => Promise<void>;
}

const EmailMessageComponent = ({
  title,
  message,
  closing,
  helpRequestResponse = "blue",
  onResendClick,
}: EmailMessageComponentProps) => {
  const [hasSent, setHasSent] = useState(false);

  const handleClick = async () => {
    if (onResendClick) {
      await onResendClick();
      setHasSent(true);
    }
  };

  return (
    <div
      className={
        helpRequestResponse === "green"
          ? "sid-email-msg-container sid-l-horz-center sid-l-space-top-md sid-email-msg-container--bg-green"
          : "sid-email-msg-container sid-l-horz-center sid-l-space-top-md sid-email-msg-container--bg-blue"
      }
    >
      <div className="sid-email-msg-container__title">{title}</div>
      <div className="sid-email-msg-container__content">{message}</div>
      <div className="sid-email-msg-container__content sid-email-msg-container__closing">
        {closing}
      </div>
      <div className="sid-email-resend-area">
        <button
          type="button"
          className={
            hasSent
              ? "sid-email-resend-area__button sid-email-resend-area__button__sent"
              : "sid-email-resend-area__button"
          }
          onClick={handleClick}
          disabled={hasSent}
        >
          <FormattedHTMLMessage
            id={
              hasSent
                ? "step.personalInfo.emailFirstCollectInfo.sent"
                : "step.personalInfo.emailFirstCollectInfo.sendAgain"
            }
            defaultMessage={hasSent ? "Sent!" : "Send Again"}
          />
        </button>
      </div>
    </div>
  );
};

export { EmailMessageComponent };
